import { useTranslation } from 'react-i18next'
import { Controller, type UseFormReturn } from 'react-hook-form'

import { Flex, FormField, TextArea, TextInput } from '@percent/lemonade'
import type { ServiceFormValues } from './serviceForm'

type ServiceFormFieldsProps = {
  form: UseFormReturn<ServiceFormValues>
  /** Prefixes the inputs' test ids, e.g. `create-service-name-input`. */
  dataTestId: string
}

export function ServiceFormFields({ form, dataTestId }: Readonly<ServiceFormFieldsProps>) {
  const { t } = useTranslation()
  const {
    control,
    formState: { errors }
  } = form

  return (
    <Flex direction="column" gap="md">
      <Controller
        name="name"
        control={control}
        render={({ field }) => (
          <FormField
            label={t('typography.name')}
            necessity="required"
            status={errors.name ? 'danger' : 'default'}
            statusMessage={errors.name?.message}
          >
            <TextInput
              {...field}
              placeholder={t('serviceForm.name.placeholder')}
              data-testid={`${dataTestId}-name-input`}
            />
          </FormField>
        )}
      />
      <Controller
        name="ownerTeam"
        control={control}
        render={({ field }) => (
          <FormField
            label={t('typography.ownerTeam')}
            description={t('serviceForm.ownerTeam.hint')}
            necessity="required"
            status={errors.ownerTeam ? 'danger' : 'default'}
            statusMessage={errors.ownerTeam?.message}
          >
            <TextInput
              {...field}
              placeholder={t('serviceForm.ownerTeam.placeholder')}
              data-testid={`${dataTestId}-owner-team-input`}
            />
          </FormField>
        )}
      />
      <Controller
        name="description"
        control={control}
        render={({ field: { ref, ...field } }) => (
          <FormField
            label={t('typography.description')}
            status={errors.description ? 'danger' : 'default'}
            statusMessage={errors.description?.message}
          >
            <TextArea
              {...field}
              placeholder={t('serviceForm.description.placeholder')}
              data-testid={`${dataTestId}-description-input`}
            />
          </FormField>
        )}
      />
    </Flex>
  )
}
